import React from 'react'
import Back from '../../common/Back'
import Featured from '../Home/Featured/Featured'
import i from '../images/fashion2.png'

const Service = () => {
  return (
    <>
      <section className="services mb">
        <Back name='Services' title='Services -All Services' cover={i}/>
        <div className="featured container">
            <Featured/>
        </div>
      </section>
    </>
  )
}

export default Service
